import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../store/DataContext';
import { User, Lock, Eye, EyeOff } from 'lucide-react';
export const Login: React.FC = () => {
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const {
    login
  } = useData();
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const result = login(fullName, password);
    if (result.ok) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Invalid username or password');
    }
  };
  return <div className="min-h-screen flex items-center justify-center px-4" style={{
    background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 50%, #f43f5e 100%)'
  }} data-id="element-3187" data-mp="2ylqv7polbf4p">
      <div className="w-full max-w-md" data-id="element-3188" data-mp="3r4xmxpnsdw4i">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-3189" data-mp="2rgsq404mdid4">
          {/* Header Section */}
          <div className="pt-10 pb-6 px-8 text-center" data-id="element-3190" data-mp="2mihhfsq29dwh">
            <div className="flex justify-center mb-4" data-id="element-3191" data-mp="2mfv0j2ha5m1l">
              <div className="h-28 w-28 rounded-full border-4 border-purple-500 p-1 flex items-center justify-center bg-white shadow-lg" data-id="element-3192" data-mp="317x715duvdal">
                <img src="https://cdn.magicpatterns.com/uploads/3HmLapdTMRvTJbmSkdh1g8/Bmedhospital.png" alt="BMED Medical Centre" className="h-20 w-20 object-contain rounded-full" data-id="element-3193" data-mp="2we2dzbcd1lyu" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-pink-600 tracking-wide" data-id="element-3194" data-mp="3k4ydyvqyznh6">
              BMED MEDICAL CENTRE
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-3195" data-mp="3f4seitegkwoj">Caring Healing Leading</p>
          </div>

          {/* Form Section */}
          <div className="px-8 pb-8" data-id="element-3196" data-mp="1kt5aqhdl9lw0">
            <form onSubmit={handleLogin} className="space-y-5" data-id="element-3197" data-mp="1ku6powxq6sj0">
              <div data-id="element-3198" data-mp="2ahj71huz0rq9">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3199" data-mp="2ai2nsv8vxa2p">
                  Full Name
                </label>
                <div className="relative" data-id="element-3200" data-mp="2ekfkyv9kfznv">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3201" data-mp="2jh6822jsfvis">
                    <User className="h-5 w-5 text-gray-400" data-id="element-3202" data-mp="2ohk6qtzi1t45" />
                  </div>
                  <input type="text" required value={fullName} onChange={e => setFullName(e.target.value)} placeholder="e.g. Chanda Mwale" className="block w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors" data-id="element-3203" data-mp="2tg58wyybamv8" />
                </div>
              </div>

              <div data-id="element-3204" data-mp="3h699exg7e6i0">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3205" data-mp="3h5ppjb6zt81c">
                  Password
                </label>
                <div className="relative" data-id="element-3206" data-mp="10iriq3m541s6">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3207" data-mp="10hq5ptlkd57t">
                    <Lock className="h-5 w-5 text-gray-400" data-id="element-3208" data-mp="vkg83qo0tn8w" />
                  </div>
                  <input type={showPassword ? 'text' : 'password'} required value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors" data-id="element-3209" data-mp="qldbmum3wpcj" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-3210" data-mp="26z3ninjgwhwq">
                    {showPassword ? <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-3211" data-mp="1rp6t2py8qlty" /> : <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-3212" data-mp="1csftogokha4c" />}
                  </button>
                </div>
                <p className="mt-1.5 text-xs text-gray-400" data-id="element-3213" data-mp="1hr97ybboh55k">
                  Min 6 chars, with numbers &amp; signs
                </p>
              </div>

              {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-xl border border-red-200 text-center" data-id="element-3214" data-mp="2af53hcpigr0r">
                  {error}
                </div>}

              <button type="submit" className="w-full py-3.5 rounded-xl text-white font-semibold text-base shadow-lg hover:shadow-xl transition-all duration-200 hover:opacity-95 active:scale-[0.98]" style={{
              background: 'linear-gradient(90deg, #ec4899 0%, #f43f5e 100%)'
            }} data-id="element-3215" data-mp="20p3i4sojlmpj">
                Sign In
              </button>
            </form>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-white text-xs mt-6 opacity-80" data-id="element-3216" data-mp="rfp153rae0ps">
          © 2026 BMED Medical Centre. All rights reserved.
        </p>
      </div>
    </div>;
};